export default __webpack_public_path__ + "static/media/auth-new-intro-3.52984352.svg";